<template>
  <v-card class="secondary">
    <v-card-title class="primary white--text"> Upload Failed </v-card-title>
    <v-card-text class="mt-4">
      <div class="subtitle-2">
        Your upload could not be completed because some records contain errors.
        <br /><br />
        Please download the error file, correct the issues, and try uploading
        again.
      </div>
    </v-card-text>
    <v-card-actions class="d-flex justify-end">
      <v-btn class="primary" @click="downloadCsv"> Download</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    errorCsvBlob: {
      type: Blob,
      default: () => null,
    },
    csvTitle: {
      type: String,
      default: "",
    },
  },
  methods: {
    async downloadCsv() {
      await this.$store.dispatch("downloadErrorCsv", {
        errorCsvBlob: this.errorCsvBlob,
        csvTitle: this.csvTitle,
      });
      this.$emit("downloaded");
    },
  },
};
</script>
